import { Notice, Spacer, Text } from '@vapor/ui';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import { Content } from '../components/boxes/content';
import { imprint } from '../content/imprint';
import { MarketingLayout } from '../layout/marketing';

export default function Privacy() {
  let [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window == 'undefined') return;

    setTimeout(() => {
      setShow(true);
    }, 500);
  }, []);

  return (
    <MarketingLayout>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>

      <Content style={{ maxWidth: 800 }}>
        <Notice>
          An imprint is required by Austrian law, hence it is in German. <br /> If you have any
          questions or concerns please email tobias@weekrise.com
        </Notice>

        <Spacer height={20} />

        <Text as="h1" size={40} weight={600}>
          Impressum
        </Text>
        <Spacer height={20} />
        <p>
          Informationspflicht lt. §5 E-Commerce Gesetz, §14 Unternehmensgesetzbuch bzw. §63
          Gewerbeordnung und Offenlegungspflicht lt. §25 Mediengesetz
        </p>

        <Spacer height={20} />

        <div dangerouslySetInnerHTML={{ __html: show ? imprint : '' }} />
      </Content>
    </MarketingLayout>
  );
}
